module.exports = __webpack_public_path__ + "static/media/kingOfCapot-0.50c7e86d.png";